// extracted by mini-css-extract-plugin
module.exports = {"investors":"SpeakerCards_investors__3aL6M","btn":"SpeakerCards_btn__1FHtE","card":"SpeakerCards_card__2M_lD"};